import { elementClicked, elementViewed } from '../tagular/fallback';

document.addEventListener('DOMContentLoaded', () => {
  // Collapse All Button
  const rankingsCollapseAllBtn = document.querySelector('.accordion-rankings [data-sonic="collapse-all"]');

  if (rankingsCollapseAllBtn) {
    rankingsCollapseAllBtn.addEventListener('click', () => {
      elementClicked({
        position: 'SECONDARY',
        location: 'RANKING CARD',
        elementType: 'BUTTON',
        text: 'COLLAPSE ALL',
        actionOutcome: 'COLLAPSE',
      });
    });
  }

  // Expand All Button
  const rankingsExpandAllBtn = document.querySelector('.accordion-rankings [data-sonic="expand-all"]');

  if (rankingsExpandAllBtn) {
    rankingsExpandAllBtn.addEventListener('click', () => {
      elementClicked({
        position: 'SECONDARY',
        location: 'RANKING CARD',
        elementType: 'BUTTON',
        text: 'EXPAND ALL',
        actionOutcome: 'EXPAND',
      });
    });
  }

  // View School Profile Button
  const rankingsViewSchoolProfileBtn = Array.from(document.querySelectorAll('.accordion-rankings [data-sonic="accordion-content"] a'));

  rankingsViewSchoolProfileBtn.forEach((button, i) => {
    const cardNumber = i + 1;
    button.addEventListener('click', () => {
      elementClicked({
        position: `CARD ${cardNumber}`,
        location: 'RANKING CARD',
        elementType: 'BUTTON',
        text: 'VIEW SCHOOL PROFILE',
        actionOutcome: 'EXTERNALLINK',
      });
    });
  });

  // School Name Card
  const schoolNameCards = Array.from(document.querySelectorAll('.accordion-rankings [data-sonic="accordion-activator"]'));

  schoolNameCards.forEach((card, i) => {
    const cardNumber = i + 1;
    card.addEventListener('click', () => {
      elementClicked({
        position: `CARD ${cardNumber}`,
        location: 'RANKING CARD',
        elementType: 'BUTTON',
        text: '-/+',
        actionOutcome: 'COLLAPSE/EXPAND',
      });
    });

    // Detect when the footer widget is in the viewport
    let schoolNameCardViewed = 0;
    window.addEventListener('scroll', () => {
      // Only let the tracking fire once if it's in the viewport
      if (schoolNameCardViewed) {
        return;
      }
      if (card) {
        const bounding = card.getBoundingClientRect();
        if (
          bounding.bottom
            <= (window.innerHeight || document.documentElement.clientHeight)
        ) {
          const schoolName = card.getElementsByTagName('span')[0].innerText || '';
          elementViewed({
            position: `CARD ${cardNumber}`,
            location: 'RANKING CARD',
            elementType: 'CARD',
            text: schoolName.toUpperCase(),
          });
          schoolNameCardViewed = 1;
        }
      }
    });
  });
});
